<ng-template #richBlocksTpl let-elements>
  @for (el of elements; track $index) {
    @switch (el.tag) {
      @case ('h1') {
        <h1 [innerHTML]="el.html | safe: 'html'"></h1>
      }
      @case ('h2') {
        <h2 [innerHTML]="el.html | safe: 'html'"></h2>
      }
      @case ('h3') {
        <h3 [innerHTML]="el.html | safe: 'html'"></h3>
      }
      @case ('h4') {
        <h4 [innerHTML]="el.html | safe: 'html'"></h4>
      }
      @case ('h5') {
        <h5 [innerHTML]="el.html | safe: 'html'"></h5>
      }
      @case ('h6') {
        <h6 [innerHTML]="el.html | safe: 'html'"></h6>
      }
      @default {
        <p [innerHTML]="el.html | safe: 'html'"></p>
      }
    }
  }
</ng-template>

<ng-template #subscriptionIndicator>
  <span class="subscription-indicator" title="Subscription">
    <svg class="subscription-indicator__icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
      <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" stroke-width="1.4" />
      <path
        d="M8 4 V8 L11 9.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
    <span class="subscription-indicator__label">Delivery every 2 weeks, 30% off</span>
  </span>
</ng-template>

@if (isLineItemAction) {
  <div class="product-upgrade-example" [class.is-mobile]="isMobile">
    <!-- Line item row -->
    <div class="line-item">
      <div class="line-item__left">
        <div class="line-item__image">
          <img src="assets/icons/checkout_content_default.png" alt="Product" />
          <span class="line-item__quantity-badge">1</span>
        </div>
        <div class="line-item__details">
          <span class="line-item__name">Monstera Deliciosa</span>
          <span class="line-item__variant">2 feet</span>
          @if (showSubscriptionIndicator) {
            <ng-container *ngTemplateOutlet="subscriptionIndicator"></ng-container>
          }
          <!-- Action toggles: Modify ∨ | Upgrade ∧ -->
          <div class="action-toggles">
            <span class="action-toggles__item action-toggles__item--link">
              Modify
              <span class="action-toggles__icon">
                <pdq-icon icon="arrow_down" size="small"></pdq-icon>
              </span>
            </span>
            <span class="action-toggles__separator">|</span>
            <span
              class="action-toggles__item action-toggles__item--link"
              [attr.data-tone]="upgradeTextAppearanceTone"
              (click)="toggleUpgrade()">
              <span class="rich-inline" [innerHTML]="upgradeTextHtml | safe: 'html'"></span>
              @if (upgradeTextBadge) {
                <span
                  class="upgrade-card__badge"
                  [attr.data-radius]="upgradeTextBadge.cornerRadius"
                  [style.background-color]="upgradeTextBadge.backgroundColor"
                  [style.color]="upgradeTextBadge.textColor">
                  @if (upgradeTextBadge.icon) {
                    <pdq-icon [icon]="upgradeTextBadge.icon" size="small"></pdq-icon>
                  }
                  <span [innerHTML]="upgradeTextBadge.text | safe: 'html'"></span>
                </span>
              }
              <span class="action-toggles__icon" [class.open]="isUpgradeOpen">
                <pdq-icon icon="arrow_down" size="small"></pdq-icon>
              </span>
            </span>
          </div>
        </div>
      </div>
      <span class="line-item__price">$100.00</span>
    </div>

    <!-- Upgrade popover card (below line item, full width) -->
    @if (isUpgradeOpen) {
      <div
        class="upgrade-card upgrade-card--popover"
        [attr.data-border]="mainBorder"
        [attr.data-border-width]="mainBorderWidth"
        [attr.data-radius]="mainCornerRadius"
        [attr.data-padding]="mainPadding">
        @if (titleTextHtml) {
          <span class="upgrade-card__title-row">
            <span
              class="upgrade-card__title rich-inline"
              [attr.data-tone]="titleAppearanceTone"
              [innerHTML]="titleTextHtml | safe: 'html'"></span>
            @if (titleBadge) {
              <span
                class="upgrade-card__badge"
                [attr.data-radius]="titleBadge.cornerRadius"
                [style.background-color]="titleBadge.backgroundColor"
                [style.color]="titleBadge.textColor">
                @if (titleBadge.icon) {
                  <pdq-icon [icon]="titleBadge.icon" size="small"></pdq-icon>
                }
                <span [innerHTML]="titleBadge.text | safe: 'html'"></span>
              </span>
            }
          </span>
        }

        <div class="upgrade-card__product-row">
          <div
            class="upgrade-card__product-image"
            [attr.data-img-border]="imageBorder"
            [attr.data-img-border-width]="imageBorderWidth"
            [attr.data-img-radius]="imageCornerRadius"
            [attr.data-img-padding]="imagePadding">
            <img src="assets/icons/checkout_content_default.png" alt="Product" />
          </div>
          <div class="upgrade-card__product-info">
            <span class="upgrade-card__product-name">Product name</span>
            <span class="upgrade-card__product-price">
              <span class="upgrade-card__price-current">$9.99</span>
              <span class="upgrade-card__price-compare">$5.99</span>
              <span class="upgrade-card__price-quantity">x1</span>
            </span>
          </div>
          <div class="upgrade-card__nav-arrows">
            <span class="upgrade-card__nav-arrow upgrade-card__nav-arrow--left">
              <pdq-icon icon="side_left_arrow" size="small"></pdq-icon>
            </span>
            <span class="upgrade-card__nav-arrow upgrade-card__nav-arrow--right">
              <pdq-icon icon="side_right_arrow" size="small"></pdq-icon>
            </span>
          </div>
        </div>

        @if (showSubscriptionIndicator) {
          <ng-container *ngTemplateOutlet="subscriptionIndicator"></ng-container>
        }

        <button
          class="upgrade-card__button rich-inline"
          [attr.data-tone]="buttonAppearanceTone"
          [innerHTML]="buttonLabelHtml | safe: 'html'"></button>
      </div>
    }

    <!-- Checkout skeleton -->
    <div class="checkout-demo">
      <div class="checkout-demo__row-1">
        <div class="checkout-demo__row-1-rect">
          <div class="checkout-demo__row-1-inner"></div>
        </div>
        <div class="checkout-demo__row-1-right"></div>
      </div>
      <div class="checkout-demo__row-2-3">
        <div class="checkout-demo__row-2-3-left"></div>
        <div class="checkout-demo__row-2-3-right"></div>
      </div>
      <div class="checkout-demo__row-2-3">
        <div class="checkout-demo__row-2-3-left"></div>
        <div class="checkout-demo__row-2-3-right"></div>
      </div>
      <div class="checkout-demo__row-4">
        <div class="checkout-demo__row-4-left"></div>
        <div class="checkout-demo__row-4-right"></div>
      </div>
    </div>
  </div>
} @else if (isFocused) {
  <!-- STANDALONE + FOCUSED OFFER -->
  <div
    class="product-upgrade-example product-upgrade-example--standalone product-upgrade-example--focused"
    [class.is-mobile]="isMobile">
    <div class="checkout-skeleton">
      <div class="checkout-skeleton__product">
        <div class="checkout-skeleton__product-image">
          <img src="assets/icons/checkout_content_default.png" alt="" />
          <span class="checkout-skeleton__badge">1</span>
        </div>
        <div class="checkout-skeleton__product-details">
          <div class="checkout-skeleton__line checkout-skeleton__line--long"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--short"></div>
        </div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
      </div>

      <div class="checkout-skeleton__divider"></div>

      <div class="checkout-skeleton__discount-row">
        <div class="checkout-skeleton__discount-input"></div>
        <div class="checkout-skeleton__discount-button"></div>
      </div>
    </div>

    <div
      class="upgrade-card upgrade-card--focused"
      [attr.data-border]="mainBorder"
      [attr.data-border-width]="mainBorderWidth"
      [attr.data-radius]="mainCornerRadius"
      [attr.data-padding]="mainPadding">
      @if (titleElements.length) {
        <div class="upgrade-card__title-row upgrade-card__title-row--inside">
          <div class="upgrade-card__title" [attr.data-tone]="titleAppearanceTone">
            <ng-container *ngTemplateOutlet="richBlocksTpl; context: { $implicit: titleElements }"></ng-container>
          </div>
          @if (titleBadge) {
            <span
              class="upgrade-card__badge"
              [attr.data-radius]="titleBadge.cornerRadius"
              [style.background-color]="titleBadge.backgroundColor"
              [style.color]="titleBadge.textColor">
              @if (titleBadge.icon) {
                <pdq-icon [icon]="titleBadge.icon" size="small"></pdq-icon>
              }
              <span [innerHTML]="titleBadge.text | safe: 'html'"></span>
            </span>
          }
        </div>
        <div class="upgrade-card__title-divider"></div>
      }
      <div class="upgrade-card__focused-row">
        <div
          class="upgrade-card__product-image"
          [attr.data-img-border]="imageBorder"
          [attr.data-img-radius]="imageCornerRadius">
          <img src="assets/icons/checkout_content_default.png" alt="Product" />
        </div>
        <div class="upgrade-card__focused-info">
          <span class="upgrade-card__product-name">Product name</span>
          <span class="upgrade-card__variant-line">Variant / Variant</span>
          <span class="upgrade-card__product-price">
            <span class="upgrade-card__price-current">
              {{ focusedCurrentPrice }}
              @if (isSubscriptionPreview) {
                <span class="upgrade-card__price-frequency"> / {{ focusedFrequencyLabel }}</span>
              }
            </span>
            <span class="upgrade-card__price-compare">{{ focusedComparePrice }}</span>
            <span class="upgrade-card__price-quantity">x1</span>
          </span>
        </div>
        <button
          class="upgrade-card__button upgrade-card__button--focused rich-inline"
          [attr.data-tone]="buttonAppearanceTone"
          [innerHTML]="buttonLabelHtml | safe: 'html'"></button>
      </div>
    </div>

    <div class="checkout-skeleton">
      <div class="checkout-skeleton__totals">
        <div class="checkout-skeleton__totals-row">
          <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
        </div>
        <div class="checkout-skeleton__totals-row">
          <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
        </div>
        <div class="checkout-skeleton__divider"></div>
        <div class="checkout-skeleton__totals-row">
          <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--price-bold"></div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <!-- STANDALONE_BLOCK mode (Comparison view) -->
  <div class="product-upgrade-example product-upgrade-example--standalone" [class.is-mobile]="isMobile">
    <!-- Order summary skeleton -->
    <div class="checkout-skeleton">
      <div class="checkout-skeleton__product">
        <div class="checkout-skeleton__product-image">
          <img src="assets/icons/checkout_content_default.png" alt="" />
          <span class="checkout-skeleton__badge">1</span>
        </div>
        <div class="checkout-skeleton__product-details">
          <div class="checkout-skeleton__line checkout-skeleton__line--long"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--short"></div>
        </div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
      </div>

      <div class="checkout-skeleton__divider"></div>

      <div class="checkout-skeleton__discount-row">
        <div class="checkout-skeleton__discount-input"></div>
        <div class="checkout-skeleton__discount-button"></div>
      </div>
    </div>

    <!-- Upgrade offer card (StandaloneUpgradeOffer) -->
    <div
      class="upgrade-card"
      [attr.data-border]="mainBorder"
      [attr.data-border-width]="mainBorderWidth"
      [attr.data-radius]="mainCornerRadius"
      [attr.data-padding]="mainPadding">
      @if (titleElements.length) {
        <div class="upgrade-card__title-row">
          <div class="upgrade-card__title" [attr.data-tone]="titleAppearanceTone">
            <ng-container *ngTemplateOutlet="richBlocksTpl; context: { $implicit: titleElements }"></ng-container>
          </div>
          @if (titleBadge) {
            <span
              class="upgrade-card__badge"
              [attr.data-radius]="titleBadge.cornerRadius"
              [style.background-color]="titleBadge.backgroundColor"
              [style.color]="titleBadge.textColor">
              @if (titleBadge.icon) {
                <pdq-icon [icon]="titleBadge.icon" size="small"></pdq-icon>
              }
              <span [innerHTML]="titleBadge.text | safe: 'html'"></span>
            </span>
          }
        </div>
      }

      <!-- Source products row -->
      <div class="upgrade-card__source-row">
        <div
          class="upgrade-card__source-image"
          [attr.data-img-border]="imageBorder"
          [attr.data-img-border-width]="imageBorderWidth"
          [attr.data-img-radius]="imageCornerRadius"
          [attr.data-img-padding]="imagePadding">
          <img src="assets/icons/checkout_content_default.png" alt="" />
        </div>
        <div class="upgrade-card__source-info">
          <span class="upgrade-card__product-name">Product name A</span>
          @if (showSubscriptionIndicator) {
            <ng-container *ngTemplateOutlet="subscriptionIndicator"></ng-container>
          }
          <span class="upgrade-card__price-current">$49.99</span>
        </div>
      </div>

      <!-- "↓ Upgrade to" separator -->
      <div class="upgrade-card__separator" [attr.data-tone]="upgradeTextAppearanceTone">
        <pdq-icon icon="arrow_down" size="small"></pdq-icon>
        <span class="upgrade-card__upgrade-text">
          <ng-container *ngTemplateOutlet="richBlocksTpl; context: { $implicit: upgradeTextElements }"></ng-container>
        </span>
        @if (upgradeTextBadge) {
          <span
            class="upgrade-card__badge"
            [attr.data-radius]="upgradeTextBadge.cornerRadius"
            [style.background-color]="upgradeTextBadge.backgroundColor"
            [style.color]="upgradeTextBadge.textColor">
            @if (upgradeTextBadge.icon) {
              <pdq-icon [icon]="upgradeTextBadge.icon" size="small"></pdq-icon>
            }
            <span [innerHTML]="upgradeTextBadge.text | safe: 'html'"></span>
          </span>
        }
      </div>

      <!-- Target product row -->
      <div class="upgrade-card__product-row">
        <div
          class="upgrade-card__product-image"
          [attr.data-img-border]="imageBorder"
          [attr.data-img-radius]="imageCornerRadius">
          <img src="assets/icons/checkout_content_default.png" alt="Product" />
        </div>
        <div class="upgrade-card__product-info">
          <span class="upgrade-card__product-name">Product name B</span>
          @if (showSubscriptionIndicator) {
            <ng-container *ngTemplateOutlet="subscriptionIndicator"></ng-container>
          }
          <span class="upgrade-card__product-price">
            <span class="upgrade-card__price-current">$9.99</span>
            <span class="upgrade-card__price-compare">$5.99</span>
            <span class="upgrade-card__price-quantity">x1</span>
          </span>
        </div>
        <div class="upgrade-card__nav-arrows">
          <span class="upgrade-card__nav-arrow">
            <pdq-icon icon="side_left_arrow" size="small"></pdq-icon>
          </span>
          <span class="upgrade-card__nav-arrow">
            <pdq-icon icon="side_right_arrow" size="small"></pdq-icon>
          </span>
        </div>
      </div>

      <button class="upgrade-card__button">
        <ng-container *ngTemplateOutlet="richBlocksTpl; context: { $implicit: buttonLabelElements }"></ng-container>
      </button>
    </div>

    <!-- Totals skeleton -->
    <div class="checkout-skeleton">
      <div class="checkout-skeleton__totals">
        <div class="checkout-skeleton__totals-row">
          <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
        </div>
        <div class="checkout-skeleton__totals-row">
          <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
        </div>
        <div class="checkout-skeleton__divider"></div>
        <div class="checkout-skeleton__totals-row">
          <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
          <div class="checkout-skeleton__line checkout-skeleton__line--price-bold"></div>
        </div>
      </div>
    </div>
  </div>
}
